import {Warehouse} from "../Models/Warehouse";
import RestService from "./RestService";

const WarehouseService = {
    get: () => RestService.get<Warehouse>({endpoint: "warehouses"})
}

export default WarehouseService
